import { render, staticRenderFns } from "./handleProvider.vue?vue&type=template&id=1c7b470b&scoped=true"
import script from "./handleProvider.vue?vue&type=script&lang=js"
export * from "./handleProvider.vue?vue&type=script&lang=js"
import style0 from "./handleProvider.vue?vue&type=style&index=0&id=1c7b470b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7b470b",
  null
  
)

export default component.exports